import { Link } from 'react-router-dom';
import { TooltipStyled } from 'src/components';
import { useCurrentUser } from 'src/hooks';
import { CartApprovalStatus } from 'src/types';

export const LinkWrapper = ({
  children,
  includeLink = true,
  page,
  cartId,
  fromHistory,
}: {
  children: React.ReactNode;
  includeLink: boolean;
  page: 'get' | 'review' | 'history';
  cartId: string;
  fromHistory: boolean;
}) => {
  if (!includeLink) {
    return <div className='cursor-default'>{children}</div>;
  }

  return (
    <Link
      to={`/${page}/${cartId}`}
      className='cursor-pointer'
      {...(fromHistory && { state: { from: 'history' } })}
    >
      {children}
    </Link>
  );
};

/**
 * If the user is looking at their own cart request, we want to show a tooltip
 * with the tooltip content.
 *
 * @returns
 */
export const ShowTooltipWrapper = ({
  children,
  requestedByEmail,
  cartApprovalStatus,
}: {
  children: React.ReactNode;
  requestedByEmail: string;
  cartApprovalStatus: CartApprovalStatus;
}) => {
  const { user } = useCurrentUser();

  if (requestedByEmail === user?.email) {
    return (
      <TooltipStyled
        title={<TooltipContent rejected={cartApprovalStatus === 'rejected'} />}
        placement='top'
        arrow
      >
        <div>{children}</div>
      </TooltipStyled>
    );
  }

  return <>{children}</>;
};

const TooltipContent = ({ rejected }: { rejected: boolean }) => {
  return (
    <div className='flex w-full flex-col items-start justify-center gap-3 bg-cloudGray p-3'>
      <h4 className='heading-100'>
        {rejected ? 'Rejected' : 'Pending Approval'}
      </h4>
      <p className='text-100'>
        {rejected
          ? 'Your cart has been rejected. Please contact the Admins and Approvers in your Organization for more information.'
          : "We've submitted your cart for approval to the Admins and Approvers in your Organization. You'll get a confirmation email as soon as they've approved it."}
      </p>
    </div>
  );
};
